import React from 'react'

export const Spinner = (props) => 
  <div className="lds-tqt"><div/><div/><div/></div>


// WEBPACK FOOTER //
// ./src/images/Spinner.js